<template>
  <div>
    <b-row v-if="
      main_setting?.main_topic_info && main_setting?.main_topic_info?.sb_main_links.length > 0
    " align-items-stretch :class="{
        'justify-content-center': main_setting?.main_topic_info?.sb_main_links.length <= 2,
      }">
      <b-col cols="12" md="6" xl="4"
        v-for="(highlight_info, hightlight_idx) in main_setting?.main_topic_info?.sb_main_links"
        :key="'sb-main-card' + hightlight_idx" :ref="'card' + hightlight_idx"
        class="d-flex justify-content-center topic-card clickable"
        @click="navigateLink(lang !== 'ENG' ? highlight_info?.url : highlight_info?.url_e)">
        <div :style="[getImageStyle(hightlight_idx), { height: imageHeight }]"
          @mouseover="hoveredIndex = hightlight_idx" @mouseleave="hoveredIndex = selected_card_index"
          class="w-100 d-flex flex-column justify-content-between align-items-center section-highlight-card text-center pt-4 mb-4">
          
          <div class="my-3 my-sm-4 my-xl-5 achievement-section-title w-80">
            <h1 class="mb-0 text-center" :id="`title_highlight-card-${hightlight_idx + 1}`">
              {{ lang === 'KOR' ? highlight_info.title : highlight_info.title_e }}
            </h1>
          </div>

          <div
            class="d-flex position-relative w-100 justify-content-center align-items-center bgray-transparent">
            <div class="d-flex flex-column w-80 text-keep-all achievement-section-decription">
              <h6 class="mb-2 text-left" target="_blank">
                {{
                  lang === 'KOR'
                    ? stripTags(highlight_info?.content)
                    : stripTags(highlight_info?.content_e)
                }}
              </h6>
              <h5 class="text-left">
                {{ lang === 'KOR' ? highlight_info?.sub_title : highlight_info?.sub_title_e }}
                <IconArrow class="arrow-icon" />
              </h5>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ColorThief from 'color-thief-browser';
import IconArrow from '@/assets/icon/icon_arrow.vue';
import main_page_mixin from '@/mixins/main_page_mixin.js'

export default {
  name: 'SectionHighlight',
  mixins: [main_page_mixin],
  components: {
    IconArrow
  },
  data() {
    return {
      selected_card_index: 0,
      hoveredIndex: null,
      imageHeight: 'auto',
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapState('story_board', ['main_setting']),
  },
  methods: {
    getImageStyle(index) {
      const selectedLink = this.main_setting?.main_topic_info?.sb_main_links[index];
      return {
        backgroundImage: selectedLink?.image_path
          ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${this.$store.state.static_host + selectedLink.image_path})`
          : `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${selectedLink?.unsplash_path})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      };
    },
    stripTags(htmlString) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.clickable {
  cursor: pointer;
}

@keyframes text-fade-in {
  0% {
    opacity: 0.8;
  }

  100% {
    opacity: 1;
  }
}

.section-highlight-card {
  position: relative;
  opacity: 1;
  color: white;
  max-height: 720px;

  .arrow-icon,
  .arrow-icon2 {
    width: 0;
    transition: width 300ms ease-in-out;
  }

  :hover {
    .arrow-icon {
      width: 24px;
    }

    .arrow-icon2 {
      width: 16px;
    }
  }

  @media screen and (max-width: 575.98px) {
    height: calc((100vw - 32px) * 512.5 * 0.8 / 576);
  }

  @media screen and (min-width: 576px) and (max-width: 767.98px) {
    height: calc((80vh - 180px) / 2 * 0.8);
  }

  @media screen and (min-width: 768px) {
    height: calc((80vh - 180px) * 0.8);
  }

  @keyframes height-change1 {
    0% {
      height: calc((80vh - 180px) * 0.1);
    }

    100% {
      height: calc((80vh - 180px) * 0.8);
    }
  }

  @keyframes height-change2 {
    0% {
      height: calc((80vh - 180px) * 0.8);
    }

    100% {
      height: calc((80vh - 180px) * 0.1);
    }
  }

  .section-highlight-filter {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .section-highlight-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    opacity: 1;
    transition:
      opacity 500ms ease-in-out 1000ms,
      transform 300ms ease-in-out;
  }

  .section-highlight-description {
    color: white;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    opacity: 1;
    visibility: collapse;

    .section-highlight-btn {
      opacity: 0;
    }

    p {
      line-height: 1.5;

      @media screen and (max-width: 767.98px) {
        font-size: 16px;
      }

      @media screen and (min-width: 768px) and (max-width: 991.98px) {
        font-size: 14px;
      }

      @media screen and (min-width: 992px) and (max-width: 1199.98px) {
        &:not(.en) {
          font-size: 14px;
        }

        &.en {
          font-size: 14px;
        }
      }

      @media screen and (min-width: 1200px) and (max-width: 1439.98px) {
        &:not(.en) {
          font-size: 1.1vw;
        }

        &.en {
          font-size: 1.2vw;
          font-weight: 300;
        }
      }

      @media screen and (min-width: 1440px) {
        &:not(.en) {
          font-size: 1vw;
        }

        &.en {
          font-size: 0.9vw;
        }
      }
    }
  }
}

.section-highlight-label {
  opacity: 1;
}

h6 {
  margin-top: 0;
}

h1 {
  font-size: 2.5rem;
}

.text-box {
  min-height: 40%;
}

.topic-card {
  min-height: calc(80vh - 190px);
  max-height: 720px;
}
</style>
